const buildComponentConfigItem = (component, props, listeners) => ({ component, props, listeners });

const ParamTypeHelper = { buildComponentConfigItem };

export default ParamTypeHelper;
